export default "__VITE_ASSET__f4iNi3MD__"